import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

export interface RawItemVariant {
  id: number;
  color: string;
  rawItem: {
    id: number;
    itemName: string;
    sku: string;
  };
}

export interface RawItemVariantCreateRequest {
  color: string;
  rawItemId: number;
}

class RawItemVariantApiService extends BaseApiService {
  // Create multiple color variants for a raw item
  async createMultipleVariantsForRawItem(rawItemId: number, colors: string[]): Promise<RawItemVariant[]> {
    try {
      const response = await this.makeRequest<ApiResponse<RawItemVariant[]>>(
        API_ENDPOINTS.RAW_ITEM_VARIANTS.CREATE_MULTIPLE(rawItemId.toString()),
        {
          method: HTTP_METHODS.POST,
          body: JSON.stringify(colors),
        }
      );
      if (response.success) {
        toast.success(`${colors.length} color variants created successfully`);
        return response.data;
      }
      throw new Error(response.message || 'Failed to create variants');
    } catch (error) {
      toast.error('Failed to create color variants');
      throw error;
    }
  }

  // Get variants for a specific raw item
  async getVariantsByRawItemId(rawItemId: number): Promise<RawItemVariant[]> {
    try {
      const response = await this.makeRequest<ApiResponse<RawItemVariant[]>>(
        API_ENDPOINTS.RAW_ITEM_VARIANTS.GET_BY_RAW_ITEM(rawItemId.toString()),
        {
          method: HTTP_METHODS.GET,
        }
      );
      if (response.success) {
        return response.data;
      } else {
        throw new Error(response.message || 'Failed to fetch variants');
      }
    } catch (error) {
      // console.error('Error fetching variants:', error);
      toast.error('Failed to fetch raw item variants');
      throw error;
    }
  }

  // Delete all variants for a specific raw item
  async deleteVariantsByRawItemId(rawItemId: number): Promise<void> {
    try {
      const response = await this.makeRequest<ApiResponse<void>>(
        API_ENDPOINTS.RAW_ITEM_VARIANTS.DELETE_BY_RAW_ITEM(rawItemId.toString()),
        {
          method: HTTP_METHODS.DELETE,
        }
      );
      if (response.success) {
        toast.success('Raw item variants deleted successfully');
      } else {
        throw new Error(response.message || 'Failed to delete variants');
      }
    } catch (error) {
      // console.error('Error deleting variants:', error);
      toast.error('Failed to delete raw item variants');
      throw error;
    }
  }

  // Get variants for a specific raw item (if needed in future)
  // async getVariantsByRawItemId(rawItemId: number): Promise<RawItemVariant[]> {
  //   try {
  //     const response = await this.makeRequest<ApiResponse<RawItemVariant[]>>(
  //       `/api/v1/inventory/raw-items/${rawItemId}/variants`,
  //       {
  //         method: HTTP_METHODS.GET,
  //       }
  //     );
  //     if (response.success) {
  //       return response.data;
  //     }
  //     throw new Error(response.message || 'Failed to fetch variants');
  //   } catch (error) {
  //     toast.error('Failed to fetch variants');
  //     throw error;
  //   }
  // }
}

export const rawItemVariantApiService = new RawItemVariantApiService();
